'use client'

import { debounce, parseAsString, useQueryState } from 'nuqs'

/** How long the URL waits for the typing to pause before it takes the query. */
export const FLOW_SEARCH_URL_DEBOUNCE_MS = 250

const flowSearchQueryParser = parseAsString.withDefault('')

/**
 * The flows gallery's brand query, persisted as `q` on `/flows` and
 * `/browse/flows`. Every hook on this key sees a keystroke at once (the
 * bar types, the grid filters), while the URL itself is written after the
 * debounce — shallow, so the cached page loader never remounts, and
 * cleared from the URL when empty.
 */
export function useFlowSearchQuery() {
  return useQueryState(
    'q',
    flowSearchQueryParser.withOptions({
      shallow: true,
      clearOnDefault: true,
      limitUrlUpdates: debounce(FLOW_SEARCH_URL_DEBOUNCE_MS),
    })
  )
}
